import {
  BlockUI,
  NgBlockUI
 }                                  from 'ng-block-ui';
import { Component, Input, OnInit } from '@angular/core';
import { NgForm }                   from '@angular/forms';
import { TranslateService }         from '@ngx-translate/core';

import { CodeTypeModel }         from '../../app-lite/core/models/code-type';
import { CompanyService }        from '../../app-lite/companies/company.service';
import { InitialUserSetupModel } from './typings/user.initial-setup';
import { LoginService }          from '../login/login.service';
import { MessagesService }       from '../../app-lite/messages/messages.service';
import { RadioModel }            from '../../app-lite/shared/controls/radio-group/typings/radio';
import { toWorkshopTypeOptions } from '../../app-lite/companies/company.workshop-types';
import { UserService }           from './user.service';

@Component({
  selector   : 'wor-verify-user',
  styles: [ require('./user.verify.component.scss') ],
  template: require('./user.verify.component.html')
})
export class VerifyUserComponent implements OnInit {
  @BlockUI('userVerifyBlock')  block  : NgBlockUI;

  @Input() countryCode   : string;
  @Input() customerId    : string;
  @Input() subscriptionId: string;
  @Input() unlockCode    : string;
  @Input() username      : string;

  hasWorkshopTypesError  = false;
  isLoadingWorkshopTypes = false;

  user          : InitialUserSetupModel = {};
  workshopTypes : Array<RadioModel>     = [];

  constructor (
    private companyService  : CompanyService,
    private loginService    : LoginService,
    private messagesService : MessagesService,
    private translateService: TranslateService,
    private userService     : UserService
  ) {}

  isWorkshopTypeMissing ( form : NgForm ) : boolean {
    return form.submitted && this.workshopTypes.length > 0 && !this.user.workshop_type;
  }

  loadWorkshopTypes () : void {
    this.hasWorkshopTypesError  = false;
    this.isLoadingWorkshopTypes = true;

    this.companyService.getCompanyTypes()
    .then(( types : Array<CodeTypeModel> ) => {
      this.workshopTypes = toWorkshopTypeOptions(types, this.translateService);
    })
    .catch(() => {
      this.hasWorkshopTypesError = true;
    })
    .finally(() => {
      this.isLoadingWorkshopTypes = false;
    });
  }

  ngOnInit () : void {
    this.user = {
      confirm_password: '',
      country_code    : this.countryCode,
      password        : '',
      unlock_code     : this.unlockCode,
      username        : this.username
    };

    if ( this.customerId && this.subscriptionId ) {
      this.verifySubscription();
    }

    this.loadWorkshopTypes();
  }

  save ( form : NgForm ) : void {
    this.block.start();

    this.userService.saveInitialSetup(this.user)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.USER_CREATED_CHARGIFY'), 'success');

      return this.loginService.login(this.user);
    })
    .catch(error => {
      this.messagesService.error(error);
    })
    .finally(() => this.block.stop());
  }

  verifySubscription () : void {
    this.userService.verifySubscription(this.customerId, this.subscriptionId)
    .catch(error => {
      this.messagesService.error(error);
    });
  }
}
